import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { GetActiveCustomerQuery } from '../../common/generated-types';
import { GET_ACTIVE_CUSTOMER } from '../../common/graphql/documents.graphql';
import { DataService } from '../../core/providers/data/data.service';
import { StateService } from '../../core/providers/state/state.service';

@Injectable({ providedIn: 'root' })
export class AccountGuard  {

    constructor(
        private stateService: StateService,
        private dataService: DataService,
        private router: Router
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        routerState: RouterStateSnapshot,
    ): Observable<boolean | UrlTree> {
        return this.stateService.select(appState => appState.signedIn).pipe(
            switchMap(signedIn => {
                if (signedIn) {
                    return of(true);
                } else {
                    return this.dataService.query<GetActiveCustomerQuery>(GET_ACTIVE_CUSTOMER).pipe(
                        map(data => {
                            if (data.activeCustomer) {
                                return true;
                            }
                            return this.router.createUrlTree(['/account/sign-in'], {
                                queryParams: { returnUrl: routerState.url },
                            });
                        }),
                    );
                }
            }),
        );
    }
}
